export const scheduleLabels = {
	en: {
		ariaLabel: 'Team Agua class schedule',
	},
	nl: {
		ariaLabel: 'Team Agua rooster',
	},
};

export const scheduleLocations = [
	{
		id: 'south',
		locationName: {
			en: 'South',
			nl: 'Zuid',
		},
		address: {
			en: 'Tandwielstraat 24',
			nl: 'Tandwielstraat 24',
		},
		postalCode: '3083 AV',
		days: [
			{
				id: 'monday',
				name: {
					en: 'Monday',
					nl: 'Maandag',
				},
				classes: [
					{
						time: '19:30 - 20:30',
						title: {
							en: 'Submission Grappling (No-Gi)',
							nl: 'Submission Grappling (No-Gi)',
						},
					},
					{
						time: '20:30 - 21:30',
						title: {
							en: 'Open Mat',
							nl: 'Open Mat',
						},
					},
				],
			},
			{
				id: 'tuesday',
				name: {
					en: 'Tuesday',
					nl: 'Dinsdag',
				},
				classes: [
					{
						time: '20:00 - 21:30',
						title: {
							en: 'Submission Grappling (No-Gi)',
							nl: 'Submission Grappling (No-Gi)',
						},
					},
				],
			},
			{
				id: 'thursday',
				name: {
					en: 'Thursday',
					nl: 'Donderdag',
				},
				classes: [
					{
						time: '19:30 - 21:00',
						title: {
							en: 'Brazilian Jiu-Jitsu (Gi)',
							nl: 'Brazilian Jiu-Jitsu (Gi)',
						},
					},
				],
			},
		],
	},
	{
		id: 'center',
		locationName: {
			en: 'Center',
			nl: 'Centrum',
		},
		address: {
			en: 'Schiedamse Vest 188',
			nl: 'Schiedamse Vest 188',
		},
		postalCode: '3011 BH',
		days: [
			{
				id: 'wednesday',
				name: {
					en: 'Wednesday',
					nl: 'Woensdag',
				},
				classes: [
					{
						time: '19:30 - 21:30',
						title: {
							en: 'Brazilian Jiu-Jitsu (Gi)',
							nl: 'Brazilian Jiu-Jitsu (Gi)',
						},
					},
				],
			},
			{
				id: 'saturday',
				name: {
					en: 'Saturday',
					nl: 'Zaterdag',
				},
				classes: [
					{
						time: '13.00 - 15:00',
						title: {
							en: 'Brazilian Jiu-Jitsu (Gi)',
							nl: 'Brazilian Jiu-Jitsu (Gi)',
						},
					},
				],
			},
			{
				id: 'sunday',
				name: {
					en: 'Sunday',
					nl: 'Zondag',
				},
				classes: [
					{
						time: '11:00 - 13:00',
						title: {
							en: 'Brazilian Jiu-Jitsu (Gi)',
							nl: 'Brazilian Jiu-Jitsu (Gi)',
						},
					},
				],
			},
		],
	},
];

const translate = (value, language) => {
	if (typeof value === 'string') return value;
	return value[language] || value.en || value.nl || '';
};

export const getLocalizedSchedule = (language) => (
	scheduleLocations.map((location) => ({
		...location,
		locationName: translate(location.locationName, language),
		address: translate(location.address, language),
		name: `${translate(location.locationName, language)} - ${translate(location.address, language)}`,
		days: location.days.map((day) => ({
			...day,
			name: translate(day.name, language),
			classes: day.classes.map((classItem) => ({
				...classItem,
				title: translate(classItem.title, language),
			})),
		})),
	}))
);
